/**
 * VueNumeral: Vue plugin - v1.0.0 (c) 2020; aburai
 *
 * @version 1.0.0
 * @author André Bunse (aburai@github.com) <andre.bunse@gmail.com>
 */
import numeral from 'numeral'
import 'numeral/locales/de'
import 'numeral/locales/en-gb'

const VueNumeral = {
  install(Vue, options = {}) {
    numeral.locale(options.lang === 'en' ? 'en-gb' : 'de')
    Vue.prototype.$numeral = function(value, format = '0.00') {
      if (typeof value === 'string' && !value.trim()) return ''
      const _value = typeof value === 'string' ? parseFloat(value) : typeof value === 'number' ? value : 0
      return numeral(_value).format(format)
    }
  }
}

export default VueNumeral

if (typeof window !== 'undefined' && window.Vue) window.Vue.use(VueNumeral)
